<template>
	<div v-if="topFilter.items" class="posts__filter-container" v-cloak>
		<ul class="posts__top-filter">
			<li v-for="item in topFilter.items" class="posts__top-filter-item">
				<label :for="item.slug" class="button button--ghost button--small posts__top-filter-button" :class="{ 'active' : topFilter.value == item.id }">
					<input @click="update(item.id, item.slug)" type="radio" v-model="topFilter.value" :value="item.id" :id="item.slug" :name="topFilter.slug">{{ escapeHtml(item.name) }}
				</label>
			</li>
		</ul>
	</div>
</template>

<script>

import axios from 'axios';
import setLanguage from './mixins/setLanguage';

export default {
	data() {
		return {
			topFilter: {},
            language: '',
		}
	},
    mixins: [setLanguage],
	props: {
		taxonomy: String
	},
	mounted() {
        this.language = this.setLanguage();
		this.loadFilters();
	},
	methods: {
		loadFilters() {
			let _this = this;
			let givenTerms = function givenTerms() {
				// Load items from given taxonomy

				let tax = _this.taxonomy;

				let fetchUrl = window.location.origin + '/wp-json/wp/v2/' + tax + '?per_page=100';

				return axios.get(fetchUrl)
				.then(response => {
					// JSON responses are automatically parsed.

					let tax_object = {
						name: tax,
						slug: tax,
						order: 1,
						value: 0,
						items: response.data
					}

					// Add 'Alle' to items array
                    let allName = 'Alle';
                    if (_this.language == 'en') {
                        allName = 'All'
                    }

					tax_object.items.splice(0,0, {name: allName, slug: 'all', id: -1});

					_this.topFilter = tax_object;
				});
			};

			let axiosQueue = [givenTerms()];
			if (axiosQueue) {
				return Promise.all(axiosQueue)
				.then(function(v) {

					_this.fillByPageLoadParamaters();

				}).catch(function(e) {
					console.error('Promise all (TopFilter) error', e);
				});
			}
		},
		update(id, slug) {
			let filterObject = {
				name: this.taxonomy,
				id: id,
				slug: slug
			}
			this.$emit('tax-updated', filterObject);
		},
		escapeHtml(unsafe) {
			return unsafe
				.replace("&amp;", "&")
				.replace("&lt;", "<")
				.replace("&gt;", ">")
				.replace("&quot;", '"')
				.replace("&#039;", "'");
		},

		fillByPageLoadParamaters() {
			let _this = this;
			if (window.location.hash && window.location.hash !== '#!/') {
				// Get URL parameters
				let onLoadParameters = decodeURIComponent(window.location.hash.replace('#!/', ''));

				// Create object from parameters
				let parametersObject = JSON.parse('{"' + decodeURI(onLoadParameters).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g,'":"') + '"}');

				if (typeof parametersObject === 'object' && parametersObject !== null) {
					for (const [key, value] of Object.entries(parametersObject)) {
						_this.topFilter.value = value;
						_this.update(value);
					}
				}
			} else {
				_this.topFilter.value = -1;
				_this.update(-1);
			}
		},

		setCheckboxAttribute(values) {
			for (var i = 0; i < values.length; i++) {
				let item = document.getElementById(values[i]);
				if (item !== undefined && item !== null) {
					item.checked = true;
				}
			};
		}
	}
}

</script>
